/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .buttons-container[_ngcontent-%COMP%]{display:flex;align-items:center}[_nghost-%COMP%]   .buttons-container[_ngcontent-%COMP%]   .item-left[_ngcontent-%COMP%]{order:1;flex:0 1 auto;align-self:auto}[_nghost-%COMP%]   .buttons-container[_ngcontent-%COMP%]   .item-right[_ngcontent-%COMP%]{order:3;flex:0 1 auto;align-self:auto}[_nghost-%COMP%]   .buttons-container[_ngcontent-%COMP%]   .item-spacer[_ngcontent-%COMP%]{order:2;flex:1 1 auto;align-self:auto}[_nghost-%COMP%]   .input-block[_ngcontent-%COMP%]{padding-top:20px}"];
export { styles as styles };
